import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { trans } from "utils/helpers"
interface ButtonToolbarShowDeletedFilter {
    onClick?: () => void,
    Callback: (id: any) => void,
    positionId?: string,
    parentModalName?:any
}
export const ButtonToolbarShowDeletedFilter: React.FC<ButtonToolbarShowDeletedFilter> = ({ onClick, parentModalName,Callback, positionId }) => {
    let profile = { isBeginner: true }; //let profile = localStorage.getItem("profile"); // type --> Profile
    const buttonToolbarProcessStarting = useRef(null);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [options, setOptions] = useState<any>()
    const [selectoptions, setSelectOptions] = useState<any>()
        const location=useLocation()
        const pathName=parentModalName?location?.pathname?.split('/')?.[location?.pathname?.split('/')?.length-1]+'__'+parentModalName:location?.pathname?.split('/')?.[location?.pathname?.split('/')?.length-1]

    function showSubMenuFunction() {
        setShowSubMenu(true)
    }
   async function getDataAsync() {
       let option:any = []

        option.push({Id:1 ,Name :"showDeleted" })
       let selected =  localStorage.getItem("ShowDeletedFilter") && JSON.parse(localStorage.getItem("ShowDeletedFilter") as any)?.[pathName]
       if(selected || selected==0){
        setSelectOptions(selected)
        Callback && Callback(selected);

        

       }
        setOptions(option)
    }
    function hideSubMenuFunction() {
        setShowSubMenu(false)
    }
    function selectboxValSetter(event) {
        if(selectoptions){
            setSelectOptions(null)
            localStorage.setItem("ShowDeletedFilter" , "0" )
            Callback && Callback("0");
            setShowSubMenu(false)
            if (buttonToolbarProcessStarting.current) (buttonToolbarProcessStarting.current as HTMLButtonElement).blur();
        

        }else{
            setSelectOptions(event.currentTarget.getAttribute('data-value'))
            localStorage.setItem("ShowDeletedFilter" ,JSON.stringify({...JSON.parse(localStorage.getItem("ShowDeletedFilter") as any),[pathName]:event.currentTarget.getAttribute('data-value')}) )
            
        
            Callback && Callback(event.currentTarget.getAttribute('data-value'));
            setShowSubMenu(false)
            if (buttonToolbarProcessStarting.current) (buttonToolbarProcessStarting.current as HTMLButtonElement).blur();
        
        }
    }

    useEffect(() => {
        getDataAsync()

    }, []);

    return (
        <> {options && <div className="toolbar-btn-wrapper">
            <button ref={buttonToolbarProcessStarting} onClick={() => { }} onFocus={showSubMenuFunction} onBlur={hideSubMenuFunction} className="btn btn-outline-primary toolbar-btn d-flex flex-column mx-1 justify-content-center align-items-center" >
                {/* <div className={`toolbar-btn__hotkey ${profile == undefined ? "" : (profile.isBeginner ? "" : "professional-customer")}`}>F6</div> */}
                <FontAwesomeIcon icon={['fas', 'filter']} width="20px" height="20px" />
                <small>{trans("Filter")}</small>
                <div className={`toolbar-btn-sub-menu mt-1 ${showSubMenu ? "" : "d-none"}`}>
                    {options && options.map((option, index) => (
                        selectoptions && option.Id ==selectoptions  ?
                        <div key={index} className="toolbar-btn-sub-menu__option selected"  data-value={`${option.Id}`} onClick={selectboxValSetter}>{trans(option.Name)}</div>
                       :
                        <div key={index} className="toolbar-btn-sub-menu__option" data-value={`${option.Id}`} onClick={selectboxValSetter}>{trans(option.Name)}</div>
                    ))}
                </div>
            </button>
        </div>
        }
        </>
    )
    }